import { render } from "./RemoteModal.vue?vue&type=template&id=219db226"
import script from "./RemoteModal.vue?vue&type=script&lang=ts"
export * from "./RemoteModal.vue?vue&type=script&lang=ts"
script.render = render

export default script